import { normalizeCompanyBranding } from '@domain/branding/CompanyBranding';
import { logger } from '@infra/telemetry/Logger';

/**
 * Une sauvegarde est une entrée NON FIABLE (fichier modifiable à la main, ancienne version, autre poste) :
 * la charte de la fiche entreprise est revérifiée à la restauration. Un logo réécrit sans métadonnées
 * est conservé ; une charte invalide (SVG, polyglotte, couleur douteuse…) est ABANDONNÉE — le reste de la
 * fiche et la sauvegarde sont restaurés normalement, les documents reprennent la charte par défaut.
 */
export function sanitizeBackupBranding(data: Record<string, unknown[]>): Record<string, unknown[]> {
  const tenants = data['tenants'];
  if (!Array.isArray(tenants) || !tenants.some((t) => hasBranding(t))) return data;
  const cleaned = tenants.map((row) => {
    if (!hasBranding(row)) return row;
    const { branding, ...rest } = row as Record<string, unknown>;
    const result = normalizeCompanyBranding(branding);
    if (result.ok) return { ...rest, branding: result.value };
    logger.warn({
      event: 'backup_branding_dropped',
      reasons: result.issues.map((i) => i.code),
    });
    return rest;
  });
  return { ...data, tenants: cleaned };
}

function hasBranding(row: unknown): boolean {
  return typeof row === 'object' && row !== null && 'branding' in row;
}
